import { render, staticRenderFns } from "./reset-password-form.vue?vue&type=template&id=6f3fe05c&scoped=true&"
import script from "./reset-password-form.vue?vue&type=script&lang=js&"
export * from "./reset-password-form.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-form.vue?vue&type=style&index=0&id=6f3fe05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fe05c",
  null
  
)

export default component.exports